import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      staticClass: "elevation-1",
      attrs: { icon: "", "max-width": "40px", "max-height": "40px" },
    },
    [
      _c(VIcon, { attrs: { size: "16px", color: "primary" } }, [
        _vm._v("\n    " + _vm._s(_vm.icon) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }